/*  ========================================================================
    # Scripts - Separator animation
    ========================================================================  */

/**
 * Script that triggers the separator animation.
 */

const SeparatorAnimation = {
  cfg: {
    elements: document.querySelectorAll('.s-separator'),
    states: {
      animateClass: 's-separator--animated'
    }
  },

  /**
   * Handle separator intersection.
   */
  handleInsersection() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(this.cfg.states.animateClass);
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    });
    this.cfg.elements.forEach((element) => {
      observer.observe(element);
    });

  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.elements) {
      this.handleInsersection();
    }
  }
};

export default SeparatorAnimation;
